export default __webpack_public_path__ + "static/media/SWT1820.34I-39822_-23654_0.78caca7c.jpg";